import * as React from 'react';

import { SegmentLabel } from '@acceligentllc/storybook';

interface OwnProps {
	label: string;
	labelTooltip?: string;
}

type Props = React.PropsWithChildren<OwnProps>;

const Section: React.FC<Props> = ({ label, labelTooltip, children }) => {
	return (
		<div className="form-box">
			<div className="user-upsert__section-label m-t-m m-b-m">
				<SegmentLabel label={label} tooltip={labelTooltip} tooltipPosition={!!labelTooltip ? 'right' : undefined} />
			</div>
			{children}
		</div>
	);
};

export default React.memo<React.FC<Props>>(Section);
